import React from "react";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import useReportForm from "./useReportForm";
const Share = () => {
  const { values, setFieldValue } = useReportForm();
  const handleEntityShareSet = (entityShare) => setFieldValue("share_request", entityShare);
  return /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: "Search for a User or Team to add as collaborator on this report.",
      onSetEntityShare: handleEntityShareSet,
      defaultSharePayload: values == null ? void 0 : values.share_request,
      entityType: "report",
      entityTitle: ""
    }
  );
};
export default Share;
